/**
 * Returns a new list of countries sorted by:
 * 1. Position in `priorityAlpha3` (in the order provided)
 * 2. Numeric `callingCode` for the remaining countries
 *
 * Does not mutate the input. Pure — safe to memoize and unit test.
 *
 * Expected shape for each item: `{ alpha3Code: string, callingCode: string }`.
 */
export function sortCountries(list, priorityAlpha3 = []) {
    return [...list].sort((a, b) => {
        const pa = priorityAlpha3.indexOf(a.alpha3Code);
        const pb = priorityAlpha3.indexOf(b.alpha3Code);

        if (pa !== -1 && pb !== -1) return pa - pb;
        if (pa !== -1) return -1;
        if (pb !== -1) return 1;

        return (
            Number.parseInt(a.callingCode, 10) -
            Number.parseInt(b.callingCode, 10)
        );
    });
}
